/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartSendingDocumentsAliases {
  AUTOCOMPLETE_DOCUMENT_TYPE = 'autocomplete-document-type',
  BTN_SEND_NEW_DOCUMENT = 'btn-send-new-document',
  CONTEXTUAL_BAR_CHANGING_DOCUMENTS_MY_CHART_SENDING_DOCUMENTS = 'contextual-bar-changing-documents-my-chart-sending-documents',
  DECK_RECEIVED = 'deck-received',
  DECK_SENT = 'deck-sent',
  FETCH_DOCUMENTS_TYPE_LIST = 'fetch-documents-type-list',
  FETCH_RECEIVED = 'fetch-received',
  FETCH_SENT = 'fetch-sent',
  FIELD_FIELD_SENDING_DOCUMENTS_TYPE = 'field-field-sending-documents-type',
  FILTER_SENDING_DOCUMENTS = 'filter-sending-documents',
  FRAGMENT_REFERENCE_ANALYTICS = 'fragment-reference-analytics',
  LAYOUT_MY_CHART_UPLOAD = 'layout-my-chart-upload',
  MAPPER_DOCUMENT_TYPE = 'mapper-document-type',
  MY_CHART_FILE_LIST_ITEM_CARD_RECEIVED = 'my-chart-file-list-item-card-received',
  MY_CHART_FILE_LIST_ITEM_CARD_SENT = 'my-chart-file-list-item-card-sent',
  PANEL_MY_CHART_UPLOAD_MY_CHART_SENDING_DOCUMENTS = 'panel-my-chart-upload-my-chart-sending-documents',
  TAB_CONTROL = 'tab-control',
  TAB_RECEIVED = 'tab-received',
  TAB_SENT = 'tab-sent',
  TEXT_COUMENT_TYPE = 'text-coument-type',
}
export { MyChartSendingDocumentsAliases };
